"use strict";
/*
    These files are based on the Figma file:
    https://www.figma.com/file/MFiT49pcOXpVZcxFsNg0JT/Swegon-Design-Suite?node-id=457%3A13
    
    Import the elevations with: box-shadow: ${<elevationName>};
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerShadow = exports.ElevationShadow3 = exports.ElevationShadow2 = exports.ElevationShadow1 = void 0;
// 3dp
exports.ElevationShadow1 = `
    0px 3px 3px rgba(0, 0, 0, 0.14), 
    0px 3px 4px rgba(0, 0, 0, 0.12),
    0px 1px 8px rgba(0, 0, 0, 0.2);
`;
// 6dp
exports.ElevationShadow2 = `
    0px 2px 6px rgba(12, 46, 16, 0.12),
    0px 6px 12px rgba(12, 46, 16, 0.1);
`;
// 9dp
exports.ElevationShadow3 = `
    0px -1px 12px rgba(0, 0, 0, 0.06),
    0px 15px 16px rgba(0, 0, 0, 0.08), 
    0px 5px 14px rgba(0, 0, 0, 0.07);
`;
// 1dp
exports.InnerShadow = `
    inset 0px 0px 1px rgba(0, 0, 0, 0.11),
    inset 0px 0px 3px rgba(0, 0, 0, 0.1);
`;
//# sourceMappingURL=elevation.js.map